import { PaymentMeanDetailsModalContainer } from './containers';
import * as constants from './constants';
import reducer from './reducer';
const containers = { PaymentMeanDetailsModalContainer: PaymentMeanDetailsModalContainer };
const paymentMeanDetailsModalModule = { containers, constants, reducer };
export default paymentMeanDetailsModalModule;
